/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IDREfazenda } from '../../../shared/services/api/Financeiro/Relatorios';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

async function RDREfazenda(Data: IDREfazenda[], periodo: string){

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous'; 
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl =  process.env.REACT_APP_URL_IMGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  const documentDefinition : any = {
    pageSize: 'A4',  
    pageMargins: [5, 5, 5, 10], 
    pageOrientation: 'landscape', 
    content: [
      {
        table: {
          margin: [0, 0, 0, 0],  
          widths: [48, 800],  
          body: [
            [ 
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },  
              {
                border: [false, false, false, false],
                table: {
                  widths: [755],
                  body: [
                    [ 
                      {text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16,  margin: [0, 5, 0, 0], bold: true, color: 
                        process.env.COR_RELATORIOS_TEXTO,  alignment: 'center', fillColor: process.env.COR_RELATORIOS, border: [false, false, false, false]},
                    ],
                    [ 
                      {text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true]},
                    ],
                    [ 
                      {text: 'Resultado por Fazenda', margin: [5, 10, 0, 0], fontSize: 18, bold: true,  alignment: 'center',  
                        border: [false, false, false, false]},
                    ],
                  ]
                }
              }
            ],
          ]   
        }
      },
      { text: periodo,  alignment: 'left', fillColor: '#dddddd', fontSize: 8},     
      Data.map(e => {
        const { receitas, pagas, estoque, os } = e;

        const Treceita = receitas.reduce((acc, item) => acc + item.valor, 0);
        const Tpagas = pagas.reduce((acc, item) => acc + item.valor, 0);
        const Testoque = estoque.reduce((acc, item) => acc + item.valor, 0);
        const Tos = os.reduce((acc, item) => acc + item.valor, 0);

        const saldo = Treceita - Tpagas - Testoque - Tos;

        const re = receitas.map((rowos) => {
          return [
            {text: rowos.cultivo, alignment: 'left',  fontSize: 6, border: [true, false, false, true]},
            {text: rowos.planoconta, alignment: 'left',  fontSize: 6, border: [true, false, false, true]},
            {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(rowos.valor), 
              alignment: 'right',  fontSize: 6, border: [true, false, false, true]},
          ];
        }); 

        const pa = pagas.map((rowos) => {
          return [
            {text: rowos.cultivo, alignment: 'left',  fontSize: 6, border: [true, false, false, true]},
            {text: rowos.planoconta, alignment: 'left',  fontSize: 6, border: [true, false, false, true]},
            {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(rowos.valor), 
              alignment: 'right',  fontSize: 6, border: [true, false, false, true]},
          ];
        }); 

        const est = estoque.map((rowos) => {
          return [
            {text: rowos.cultivo, alignment: 'left',   fontSize: 6,  border: [true, false, false, true]},
            {text: rowos.operacao, alignment: 'left',  fontSize: 6,  border: [true, false, false, true]},
            {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(rowos.valor), 
              alignment: 'right',  fontSize: 6,  border: [true, false, false, true]},
          ];
        }); 

        const ordem = os.map((rowos) => {
          return [
            {text: rowos.numero, alignment: 'left',  fontSize: 6,  border: [true, false, false, true]},
            {text: rowos.descricao, alignment: 'left',  fontSize: 6,  border: [true, false, false, true]},
            {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(rowos.valor), 
              alignment: 'right',  fontSize: 6,  border: [true, false, false, true]},
          ];
        }); 

        return [
          [             
            [ 
              {
                table: {    
                  widths: [457, 351],
                  body: [
                    [ 
                      {text: e.fazenda, 
                        fillColor: '#dddddd', 
                        fontSize: 18, bold: true, 
                        alignment: 'left',  
                        border: [true, true, false, true],
                      },
                      {text: 'Saldo: ' + new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(saldo), 
                        alignment: 'right',
                        fillColor: '#dddddd', 
                        fontSize: 18, bold: true, 
                        border: [false, true, true, true],
                      },
                    ],
                  ]
                }
              },
              {     
                margin: [0, 0, 0, 0],
                table: { 
                  widths: [200, 1, 200, 1, 190, 1, 170],
                  body: [
                    [
                      {text: 'Recebimentos', fillColor: '#dddddd', fontSize: 8, alignment: 'left', border: [true, false, true, false] },
                      {text: '', fontSize: 8, fillColor: '#5e5e5e', margin: [-3, 0, 0, 0], border: [false, false, false, false] },
                      {text: 'Pagamentos', fontSize: 8, alignment: 'left', border: [true, false, true, false] },
                      {text: '', fillColor: '#5e5e5e', alignment: 'left', border: [false, false, false, false] },
                      {text: 'Estoque', fontSize: 8, alignment: 'left', border: [true, false, true, false]},
                      {text: '', fillColor: '#5e5e5e', alignment: 'left', border: [false, false, false, false] },
                      {text: 'Ordem de Serviços', fontSize: 8, alignment: 'left', border: [true, false, true, false] },
                    ],     
                    [
                      {   
                        margin: [-5, -3, 0, 0],  
                        table: {   
                          widths: [42, 100, 40],
                          body: [
                            [
                              {text: 'Cultivo', fontSize: 8, alignment: 'left', border: [true, false, false, true] },
                              {text: 'Plano de Conta', fontSize: 8, alignment: 'left', border: [false, false, false, true] },
                              {text: 'Valor',  fontSize: 8, alignment: 'right', border: [false, false, false, true] },
                            ],
                            ...re
                          ] 
                        }, 
                        border: [true, true, true, false],        
                      },
                      {text: '', fillColor: '#5e5e5e',  border: [false, false, false, false]   },
                      {   
                        margin: [-5, -3, 0, 0],  
                        table: { 
                          widths: [42, 100, 40],  
                          body: [
                            [
                              {text: 'Cultivo', fontSize: 8, alignment: 'left' },
                              {text: 'Plano de Conta', fontSize: 8, alignment: 'left' },
                              {text: 'Valor', fontSize: 8, alignment: 'right' },
                            ],
                            ...pa
                          ] 
                        },   
                        border: [true, true, true, false], 
                      },        
                      {text: '', fillColor: '#5e5e5e', border: [false, false, false, false]   },
                      {   
                        margin: [-5, -3, 0, 0],  
                        table: { 
                          widths: [45, 87, 40],
                          body: [
                            [
                              {text: 'Cultivo', fontSize: 8, alignment: 'left' }, 
                              {text: 'Operação', fontSize: 8, alignment: 'left' },
                              {text: 'Valor', fontSize: 8, alignment: 'right' },
                            ],
                            ...est
                          ]      
                        },  
                        border: [true, true, true, false],  
                      },                
                      {text: '', fillColor: '#5e5e5e', border: [false, false, false, false]   },
                      {   
                        margin: [-5, -3, 0, 0],  
                        table: { 
                          widths: [30, 92, 30],
                          body: [   
                            [
                              {text: 'Numero', fontSize: 8, alignment: 'left' },
                              {text: 'Patrimonio', fontSize: 8, alignment: 'left' },
                              {text: 'Valor', fontSize: 8, alignment: 'right' },
                            ],
                            ...ordem  
                          ] 
                        },  
                        border: [true, true, true, false],       
                      },    
                    ],
                    [
                      {text: 'Total: '+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(Treceita), 
                        alignment: 'right',  fillColor: '#dddddd', border: [true, false, true, true] },
                      {text: '', fillColor: '#5e5e5e', alignment: 'left', border: [false, false, false, true] },
                      {text: 'Total: '+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(Tpagas), 
                        alignment: 'right', fillColor: '#dddddd',  border: [true, false, true, true] },
                      {text: '', fillColor: '#5e5e5e', alignment: 'left', border: [false, false, false, true] },
                      {text: 'Total: '+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(Testoque), 
                        alignment: 'right', fillColor: '#dddddd',  border: [true, false, true, true]}, 
                      {text: '', fillColor: '#5e5e5e', alignment: 'left', border: [false, false, false, true] },
                      {text: 'Total: '+new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(Tos), 
                        alignment: 'right', fillColor: '#dddddd', border: [true, false, true, true] },
                    ],    
                    [
                      {text: '', border: [false, false, false, false]   },
                      {text: '', border: [false, false, false, false]   },
                      {text: '', border: [false, false, false, false]   },
                      {text: '', border: [false, false, false, false]   },
                      {text: '', border: [false, false, false, false]   },
                      {text: '', border: [false, false, false, false]   },
                      {text: '', border: [false, false, false, false]   },
                    ],    
                  ] 
                },     
              },         
            ]
          ]                             
            
        ];
      }     
      ),
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true
      },
      subheader: {
        fontSize: 15,
        bold: true
      },
      quote: {
        italics: true
      },
      small: {
        fontSize: 8
      }
    }
  };
  pdfMake.createPdf(documentDefinition).open();
}
export default RDREfazenda; 


